import {
  ChartDataset,
  ChartStyle
} from "state/ui/editor/elements/ChartElement";
import PieChart from "./PieChart";

interface Props {
  dataset: ChartDataset;
  style: ChartStyle;
  width: number;
  height: number;
}

const DonutChart = (props: Props) => (
  <PieChart {...props} innerRadiusRatio={0.55} />
);

export default DonutChart;
